export default (cgc) => {

  if (!cgc)
    cgc = ""

  cgc = cgc.trim()

  if (!cgc)
    return ""

  let str = ""  

  if (cgc.length == 14) {

    str = cgc.substring(0, 2)
    str += "." + cgc.substring(2, 5)
    str += "." + cgc.substring(5, 8)
    str += "/" + cgc.substring(8, 12)
    str += "-" + cgc.substring(12, 14)

  } else {

    str = cgc.substring(0, 3)
    str += "." + cgc.substring(3, 6)
    str += "." + cgc.substring(6, 9)
    str += "-" + cgc.substring(9, 11)    
  }

  return str
}